import React from 'react';
import Nav from './nav';
import { Link } from 'react-router-dom';

function Calender() {
  const baseURL = process.env.REACT_APP_API_BASE_URL;

  return (
    <>
      <Nav />
      <div className="container">
        <div className="row calendar-row">
          <div className="col-sm-3">
            <Link to="/calender-flow/1">
            <img src={`${baseURL}/images/design/c1.jpeg`}  className='design_image' />
            <p className='calender-title'>Calendar</p>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}

export default Calender;
